<template>
    <div>
        <v-container class="mt-3" style="max-width: 900px;" v-if="store">
        <v-row align="start" justify="center">
            <v-col cols="12" sm="4" style="text-align: center;">
                <v-avatar color="yellow darken-2" size="140" style="border: 3px solid;">
                   <img :src="store.attributes.logoUrl" alt="">
                </v-avatar>
            </v-col>

            <v-col cols="12" sm="8">
                <h3 class="mb-3">
                    {{ store.attributes.name }}
                    <v-chip
                        class="ml-1"
                        :color="store.attributes.status == 'active' ? 'success' : ''"
                        :text-color="store.attributes.status == 'active' ? 'white' : 'black'"
                        small
                        label
                        style="vertical-align: middle;"
                        >
                        <v-avatar left>
                            <v-icon v-if="store.attributes.status == 'active'">mdi-lock-open-outline</v-icon>
                            <v-icon v-else>mdi-lock-outline</v-icon>
                        </v-avatar>
                        {{ store.attributes.status == 'active' ? 'ABIERTO' : 'CERRADO' }}
                    </v-chip>
                </h3>

                <p class="body-2 black--text mb-1" v-if="!descriptionComplete">
                    {{store.attributes.description.slice(0, 120)}}
                    <span v-if="store.attributes.description.length > 120">....</span>
                    <a @click="readMore()" v-if="store.attributes.description.length > 120"> Ver más</a>
                </p>

                <p class="body-2 black--text mb-1" v-else>
                    {{store.attributes.description}}
                    <a @click="readMore()"> Ver menos</a>
                </p>

                <p class="body-2 black--text mb-1" v-if="store.attributes.acceptBankTransfer">
                    <v-icon>mdi-wallet</v-icon> Acepta pagos por: <strong>{{ getStringTransferMethods(store.attributes.transfersMethods) }}</strong>
                </p>
                
                <div>
                    <span class="pr-2 subtitle-1 black--text">
                        <v-icon>mdi-home-city-outline</v-icon>
                        {{ store.attributes.city }}
                    </span>

                    <span class="body-2 pr-2 black--text">
                        <v-icon>mdi-map-marker</v-icon>
                        {{ store.attributes.address }}
                    </span>
                </div>

                <div class="mt-2">
                <strong>Descarga y pide </strong><br>
                <a href="https://festyapp.app.link/ICH1KUMIf5">
                    <img :src="require('../assets/app_store.svg')" alt="" style="width: 90px; max-width: 200px; vertical-align: middle;">
                </a>
                <a href="https://festyapp.app.link/znRe7HEIf5">
                    <img src="https://festyapp.com/google-play-badge.png" alt="" style="max-width: 110px; vertical-align: middle;">
                </a>
                </div>

            </v-col>

        </v-row>

        <v-row v-if="products.length > 0">
            <v-col cols="12" sm="12" class="mb-10 pt-0">
            <div>
                
                <v-row>
                    <v-col
                    v-for="(product, index) in products" :key="index"
                    class="d-flex child-flex"
                    cols="6"
                    sm="6"
                    md="4"
                    >
                    <v-card>
                        <v-img
                        :src="product.attributes.imageUrl"
                        :lazy-src="product.attributes.imageUrl"
                        class="white--text align-end"
                        height="150px"
                        >
                        <v-card-text class="pa-0" style="background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)); background-position: center center;">
                            <v-row class="pa-2" align="center" justify="center">
                                <v-col cols="9">
                                    <strong>
                                        {{ product.attributes.name }}
                                        <br>
                                        {{ product.attributes.price | currency }}
                                    </strong>
                                </v-col>

                                <v-col cols="3">
                                     <v-btn icon :href="`https://promo.festyapp.com/${product.id}`" target="_blank">
                                        <v-icon class="white--text">mdi-open-in-new</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-progress-linear
                            v-if="product.attributes.featured"
                            color="teal darken-2"
                            value="100"
                        ></v-progress-linear>
                        </v-img>
                    </v-card>
        
                  
                    </v-col>
                </v-row>
                
            </div>
            </v-col>
        </v-row>

        <div class="text-center" v-if="loading">
            <v-progress-circular
            :size="70"
            color="amber"
            indeterminate
            ></v-progress-circular>
        </div>

        <v-footer
            absolute
            class="font-weight-medium"
            >
            <v-col
                class="text-center"
                cols="12"
            >
                Copyright © {{ new Date().getFullYear() }} <a class="red--text" href="https://festyapp.com" style="text-decoration: none;"> <strong>Festy</strong> </a> Todos los derechos reservados.
            </v-col>
        </v-footer>

        </v-container>

        <h1 v-else-if="!loading" class="text-center pt-5">No encontramos el comercio que buscas. 😬</h1>
        
    </div>
</template>

<script>
import Parse from 'parse'

export default {
    metaInfo() {
        return {
            meta: this.meta
        }
    },

    data() {
        return {
            store: '',
            products: '',
            loading: true,
            meta: [],
            description: '',
            descriptionComplete: false
        }
    },

    beforeMount(){
        window.location.href = 'https://web.festyapp.com/store/' + this.$route.params.store_id
    },

    async mounted() {
        await this.initialize();
        await this.getProducts();
        
        this.meta = [
            {
                vmid: this.store ? this.store.attributes.description : '',
                name: this.store ? this.store.attributes.name : '',
                content: this.store ? this.store.attributes.description : ''
            }
        ]

        window.hj('stateChange', this.$route.path)
        
    },

    methods: {
        async initialize () {
            let params = {
                id: this.$route.params.store_id
            }
            try {
                let store = await Parse.Cloud.run("getPublicStoreBO", params);
                this.store = store[0]
                //eslint-disable-next-line
                //console.log(store);
                //this.loading = false
                this.addViewToStore(store)
            
            } catch (error) {
                this.$snotify.error(`${error}` , 'Comercio', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }
            
        },

        async getProducts () {
            
            this.loading = true

            let params = {
                id: this.$route.params.store_id
            }
            try {
                let products = await Parse.Cloud.run("getPublicProductsBO", params);
                this.products = products
                //eslint-disable-next-line
                //console.log(this.products);
                this.loading = false
            
            } catch (error) {
                this.$snotify.error(`${error}` , 'Productos', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }
            
        },

        async addViewToStore(store){
            try {
                const params = {
                    storeId: store.id
                };
                await Parse.Cloud.run("viewStore", params);
            
            } catch (error) {
                //eslint-disable-next-line
                console.log(error);
            }
        },

        readMore(){
            this.descriptionComplete = !this.descriptionComplete
        },

        getStringTransferMethods(methods){
            if (methods && methods.length > 0) { 
                let string_methods = ''   
                for (let index = 0; index < methods.length; index++) {
                    const element = methods[index];
                    string_methods += element.name

                    if (index < methods.length - 1) {
                        string_methods += ', '
                    }
                }

                return string_methods
            }
        }
    },
}
</script>